import { useContext } from 'react';
import { FiltersContext } from 'context/filters';

const useFiltersContext = () => {
  return useContext(FiltersContext);
};

export default useFiltersContext;
